<div class="container-fluid cards-container">
    @let kpi = kpis()[0];
    <div class="row g-3">
        <div class="col-sm-6 col-lg-3">
            <kpi-card
                [title]="texts.totalMvNetworkLength.title"
                [body]="{
                    value: kpi.totalMvNetworkLength,
                    precision: texts.totalMvNetworkLength.precision,
                    suffix: texts.totalMvNetworkLength.suffix,
                }"
                [badge]="{
                    value: kpi.totalMvNetworkLengthEvolution,
                    suffix: texts.totalMvNetworkLength.badgeSuffix,
                    precision: texts.totalMvNetworkLength.badgePrecision,
                    style: kpi.totalMvNetworkLengthEvolution! > 0 ? 'success' : 'danger',
                }"
                [descriptionTitle]="texts.totalMvNetworkLength.descriptionTitle"
                [descriptionContent]="texts.totalMvNetworkLength.descriptionContent"
                [isLoading]="!kpi.organizationId"
                [error]="checkKpiErrors(kpi, 'totalMvNetworkLength')"
                cardClass="h-100"></kpi-card>
        </div>

        <div class="col-sm-6 col-lg-3">
            <kpi-card
                [title]="texts.mvBurialRate.title"
                [body]="{
                    value: kpi.mvBurialRate,
                    suffix: texts.mvBurialRate.suffix,
                    precision: texts.mvBurialRate.precision,
                }"
                [badge]="{
                    value: kpi.mvBurialRateEvolution,
                    suffix: texts.mvBurialRate.badgeSuffix,
                    precision: texts.mvBurialRate.badgePrecision,
                    style: kpi.mvBurialRateEvolution! > 0 ? 'success' : 'danger',
                }"
                [descriptionTitle]="texts.mvBurialRate.descriptionTitle"
                [descriptionContent]="texts.mvBurialRate.descriptionContent"
                [isLoading]="!kpi.organizationId"
                [error]="checkKpiErrors(kpi, 'mvBurialRate')"
                cardClass="h-100">
            </kpi-card>
        </div>

        <div class="col-sm-6 col-lg-3">
            <kpi-card
                [title]="texts.mvFeedersCount.title"
                [body]="{ value: kpi.mvFeedersCount, precision: texts.mvFeedersCount.precision }"
                [descriptionTitle]="texts.mvFeedersCount.descriptionTitle"
                [descriptionContent]="texts.mvFeedersCount.descriptionContent"
                [isLoading]="!kpi.organizationId"
                [badge]="{
                    value: kpi.mvFeedersCountEvolution,
                    precision: texts.mvFeedersCount.badgePrecision,
                    style: 'info',
                }"
                [error]="checkKpiErrors(kpi, 'mvFeedersCount')"
                cardClass="h-100">
            </kpi-card>
        </div>
        <div class="col-sm-6 col-lg-3">
            <kpi-card
                [title]="texts.mvFeedersOver70kmCount.title"
                [body]="{
                    value: kpi.mvFeedersOver70kmCount,
                    precision: texts.mvFeedersOver70kmCount.precision,
                }"
                [isLoading]="!kpi.organizationId"
                [error]="
                    checkKpiErrors(
                        kpi,
                        'mvFeedersOver70kmCount',
                        'nbMVFeederLongestName',
                        'nbMVFeederLongestLength'
                    )
                "
                [footer]="{
                    prefix: 'Départ ' + kpi.nbMVFeederLongestName + ' : ',
                    value: kpi.nbMVFeederLongestLength,
                    suffix: texts.mvFeedersOver70kmCount.footerSuffix + ' de long',
                    precision: texts.mvFeedersOver70kmCount.footerPrecision,
                }"
                cardClass="h-100">
            </kpi-card>
        </div>
    </div>

    <chart-card
        id="mvNetworkTypeEvolutionChart"
        [title]="texts.mvNetworkTypeEvolutionChart.title"
        [error]="networkTypeChartError"
        [descriptionTitle]="texts.mvNetworkTypeEvolutionChart.descriptionTitle"
        [descriptionContent]="texts.mvNetworkTypeEvolutionChart.descriptionContent"
        [isLoading]="!chartNetworkType()[0].organizationId"
        [series]="networkTypeChartSeries"
        [dataLabels]="networkTypeDataLabels"
        [stacked]="true"
        [xaxisCategories]="networkTypeXaxisCategories"
        [xaxisTitle]="texts.mvNetworkTypeEvolutionChart.xaxisTitle"
        [yaxis]="networkTypeYaxis"
        [customTooltip]="mvNetworkTypeEvolutionCustomTooltip"
        class="h-100">
    </chart-card>

    <chart-card
        id="mvUndergroundRateChart"
        [title]="chartTitle"
        [descriptionTitle]="texts.mvUndergroundRateChart.descriptionTitle"
        [descriptionContent]="texts.mvUndergroundRateChart.descriptionContent"
        [error]="errorChart"
        [isLoading]="!chartDataDep()[0].organizationId"
        [series]="chartSeries"
        [type]="'scatter'"
        [dataLabels]="dataLabels"
        [xaxisTitle]="texts.mvUndergroundRateChart.xaxisTitle"
        [xaxisTickAmount]="
            texts.mvUndergroundRateChart.xmax / texts.mvUndergroundRateChart.tickStep - 1
        "
        [yaxis]="yaxis"
        [xmin]="texts.mvUndergroundRateChart.xmin"
        [xmax]="texts.mvUndergroundRateChart.xmax"
        [precision]="texts.mvUndergroundRateChart.precision"
        [customTooltip]="mvUndergroundingRateCustomTooltip"
        class="h-100">
    </chart-card>

    <chart-card
        id="mvNetworkRenewalRateChart"
        [title]="texts.mvNetworkRenewalRateChart.title"
        [descriptionTitle]="texts.mvNetworkRenewalRateChart.descriptionTitle"
        [descriptionContent]="texts.mvNetworkRenewalRateChart.descriptionContent"
        [error]="networkRenewalRateChartError"
        [isLoading]="!chartNetworkRenewalRate()[0].organizationId"
        [series]="networkRenewalRateChartSeries"
        [dataLabels]="networkRenewalRateDataLabels"
        [stacked]="true"
        [xaxisCategories]="networkRenewalRateXaxisCategories"
        [yaxis]="networkRenewalRateYaxis"
        [xaxisTitle]="texts.mvNetworkRenewalRateChart.xaxisTitle"
        [customTooltip]="networkRenewalRateCustomTooltip"
        class="h-100"></chart-card>

    <chart-card
        id="mvNetworkOmtEvolutionChart"
        [title]="texts.mvNetworkOmtEvolutionChart.title"
        [descriptionTitle]="texts.mvNetworkOmtEvolutionChart.descriptionTitle"
        [descriptionContent]="texts.mvNetworkOmtEvolutionChart.descriptionContent"
        [error]="networkOmtChartError"
        [isLoading]="!chartNetworkOmt()[0].organizationId"
        [series]="networkOmtChartSeries"
        [dataLabels]="networkOmtDataLabels"
        [stacked]="true"
        [xaxisCategories]="networkOmtXaxisCategories"
        [yaxis]="networkOmtYaxis"
        [xaxisTitle]="texts.mvNetworkOmtEvolutionChart.xaxisTitle"
        [customTooltip]="networkOmtCustomTooltip"
        class="h-100"></chart-card>

    <geo-map-card
        [title]="texts.mvUndergroundingRateMap.title"
        [descriptionContent]="texts.mvUndergroundingRateMap.descriptionContent"
        [descriptionTitle]="texts.mvUndergroundingRateMap.descriptionTitle"
        [geometries]="geometries()"
        [isLoading]="!geometries()[0].organizationId"
        [error]="!!geometries()[0].error"
        [getStyle]="getMapStyle"
        [legendConfig]="legendConfig"
        [mapId]="'mvUndergroundingRateMap'"
        [getTooltip]="getTooltip"></geo-map-card>
</div>
